import {Component, Input, ViewEncapsulation} from '@angular/core';
import {InlineSVGConfig} from 'ng-inline-svg';

export type CircleMode = 'success' | 'warning' | 'error' | 'falsevalue' | 'primary' | 'none' | 'critical' | 'inverse' | 'black';
export type CircleSize = 'mini' | 'small' | 'normal' | 'big';


@Component({
  selector: 'in-type-circle',
  templateUrl: './type-circle.component.html',
  styleUrls: ['./type-circle.component.scss'],
  providers: [
    {provide: InlineSVGConfig, useValue: {baseUrl: ''}}
  ],
  encapsulation: ViewEncapsulation.Emulated
})
export class TypeCircleComponent {


  @Input() label = '';
  @Input() title = '';
  @Input() icon = '';
  @Input() showLabel = true;
  @Input() mode: CircleMode = 'success';
  @Input() size: CircleSize = 'normal';
  @Input() content: any = '';

}
